import { CctvStatusEnum } from '@api/enum';
import { FC, useMemo } from 'react';

interface CctvStatusBadgeProps {
    status: CctvStatusEnum;
}

const CctvStatusBadge = (props: CctvStatusBadgeProps) => {
    const { status } = props;

    const options = useMemo(() => {
        let bgClass = '';
        let label = '';

        switch (status) {
            case CctvStatusEnum.ONLINE:
                bgClass = 'bg-success-500';
                label = 'Online';
                break;
            case CctvStatusEnum.OFFLINE:
                bgClass = 'bg-danger-500';
                label = 'Offline';
                break;
            case CctvStatusEnum.LOADING:
                bgClass = 'bg-warning-500';
                label = 'Loading...';
                break;
        }

        return {
            bgClass,
            label,
        };
    }, [status]);

    return (
        <div className="flex items-center gap-2 h-10 text-sm px-4 btn-secondary font-semibold bg-white rounded-lg">
            <span className={['w-2 h-2 rounded-full', options.bgClass].join(' ')}></span>
            {options.label}
        </div>
    );
};

export default CctvStatusBadge;
